<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0">
        <div class="card-body px-lg-5 py-lg-4">
          <div class="text-center text-muted mb-4">
            <small>Set New Password to Reset Your Password</small>
          </div>
          <form role="form">
            <div class="mb-3">
              <base-input
                class="input-group-alternative mb-0"
                placeholder="New Password"
                :class="{ 'has-danger input-danger': newPassErr }"
                type="password"
                @keyup="newPassErr = false"
                addon-left-icon="ni ni-lock-circle-open"
                @keypress.enter="resetPassword"
                v-model="model.newPassword"
              >
              </base-input>
              <span
                v-show="newPassErr"
                class="text-danger"
                v-text="newPassMsg"
              ></span>
            </div>
            <div class="mb-3">
              <base-input
                class="input-group-alternative mb-0"
                placeholder="Re-enter Password"
                :class="{ 'has-danger input-danger': rePassErr }"
                type="password"
                @keyup="rePassErr = false"
                addon-left-icon="ni ni-lock-circle-open"
                @keypress.enter="resetPassword"
                v-model="model.reNewPass"
              >
              </base-input>
              <span
                v-show="rePassErr"
                class="text-danger"
                v-text="rePassMsg"
              ></span>
            </div>
            <div class="text-center">
              <base-button
                type="primary"
                class="my-4"
                @click.prevent="resetPassword"
                >Reset Password</base-button
              >
            </div>
          </form>
          <div class="row">
            <div class="col-12">
              <router-link to="/login" class="text-dark"
                ><small>Login to your account</small></router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from "@/apiList";
export default {
  name: "reset-password",
  data() {
    return {
      model: {
        newPassword: "",
        reNewPass: "",
        resetToken: this.$route.params.resetToken,
      },
      newPassErr: false,
      rePassErr: false,
      newPassMsg: "",
      rePassMsg: "",

      isSuccess: false,
    };
  },
  methods: {
    async resetPassword() {
      if (this.validateForm()) {
        let { newPassword, reNewPass, resetToken } = this.model;
        this.newPassErr = false;
        this.rePassErr = false;
        let body = { newPassword, reNewPass, resetToken };
        const data = await api.resetUserPassword(body);
        if (!data.response) {
          this.isSuccess = true;
          let res = data.data.message;
          this.$toast(res, {
            type: "success",
          });
        } else {
          let res = data.response;
          this.$toast(res.data.message, {
            type: "error",
          });
        }
      }
    },
    validateForm() {
      let { newPassword, reNewPass } = this.model;
      let hasErr = false;
      if (!newPassword) {
        this.newPassErr = true;
        this.newPassMsg = "New Password is required.";
        hasErr = true;
      }
      if (!reNewPass) {
        this.rePassErr = true;
        this.rePassMsg = "Confirm Password is required.";
        hasErr = true;
      }
      if (newPassword && reNewPass) {
        if (newPassword != reNewPass) {
          this.rePassErr = true;
          this.rePassMsg = "Passwords do not match.";
          hasErr = true;
        }
      }
      return !hasErr;
    },
    closeModel() {
      if (this.isSuccess) {
        this.$router.push("/login");
      } else {
        this.alertShow = false;
      }
    },
    atInputKeyUps(inputName) {
      if (this.model.email) this.emailErr = false;
      if (this.model.password) this.passwordErr = false;
    },
  },
  created() {
    this.model.resetToken = this.$route.params.resetToken;
  },
};
</script>
<style scoped>
.input-danger {
  border: 1px solid red;
}
.text-danger {
  color: red;
  font-size: 14px;
}
.text-dark {
  color: #324cdd !important;
  text-decoration: underline;
}
</style>
